// 小程序全部分类页面
export default {
  routes: [
    {
      path: '/lose-card',
      name: 'lose-card',
      meta: {
        desc: '失效宝贝',
        pageId: 'G4520'
      },
      component: () => import(/* webpackChunkName: "loseCard" */ '../views/loseCard/index.vue')
    }
  ]
}
